import React, { useEffect, useState } from 'react';
import { CommandInput } from '@dashboard/components/ui/command';
import { useCommandPalette } from './CommandPaletteContext';

const DEBOUNCE_MS = 150;

export function PaletteInput() {
  const { query, setQuery } = useCommandPalette();
  const [local, setLocal] = useState(query);

  useEffect(() => {
    setLocal(query);
  }, [query]);

  useEffect(() => {
    if (local === query) return;
    const t = window.setTimeout(() => setQuery(local), DEBOUNCE_MS);
    return () => window.clearTimeout(t);
  }, [local, query, setQuery]);

  return (
    <CommandInput placeholder="Search or type a command…" value={local} onValueChange={setLocal} />
  );
}
